import cx from 'classnames';
import { noop } from 'lodash';
import React from 'react';
import styles from '../../../styles/kpi.module.scss';
import { TEST_IDS } from './constants';
export const Sublabel = React.memo(({ text, isPresentModeOn, onPointClick, onPointDoubleClick, isAggregationEnabled, isKPIWithAnomalyV2Enabled = false, }) => {
    return (React.createElement("div", { onClick: onPointClick, onDoubleClick: onPointDoubleClick, onKeyDown: noop, role: !isAggregationEnabled ? 'button' : '', tabIndex: 0, "data-testid": TEST_IDS.SUBLABEL, className: cx(styles.sublabelWrapper, {
            [styles.liteLeftPadding]: isKPIWithAnomalyV2Enabled,
        }) },
        React.createElement("span", { className: cx(styles.sublabel, {
                [styles.subLabelAnomalyV2]: isKPIWithAnomalyV2Enabled,
                [styles.sublabelPresent]: isPresentModeOn,
            }), "data-tooltip-content": text }, text)));
});
//# sourceMappingURL=sublabel.js.map